import { useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';

import { convertMsalAccountToUser } from '../utils/msal-user-convert';

import type { AuthContextValue } from '../types';

// ----------------------------------------------------------------------

export function useAuthContext(): AuthContextValue {
  const { instance, inProgress } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const authenticated = !!activeAccount;
  const loading = inProgress !== InteractionStatus.None;
  const unauthenticated = !authenticated && !loading;

  return {
    authenticated,
    loading,
    unauthenticated,
    user: activeAccount ? convertMsalAccountToUser(activeAccount) : null,
  };
}
